import React from 'react';
import LoadingDataCard from 'components/Cards/LoadingDataCard';
import { Button, Icon, Tag, Link, Flex } from '@chakra-ui/react';
import TabField from 'components/dataDispaly/TabField';

import { getAddressView } from 'utils/index';
import { viewDateAndTime } from 'utils/date';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CiEdit } from 'react-icons/ci';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { viewMobile } from 'utils/number';
import { mapResponseToDefaults } from 'utils/default-util';
import { REALTOR_DEFAULT_VALUE } from 'constants/consumer';
import RealtorForm from 'components/Forms/RealtorForm';

export default function ViewPersonal({ isLoading = false , data = {} , refetch }) {
    const history = useHistory();
    const searchparams = new URLSearchParams(history.location.search);
    const isEdit = searchparams.get('isEdit') === 'true';

    const handleEdit = ()=>{
        setisEdit(!isEdit);
    };

    const setisEdit = ()=>{
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('isEdit', !isEdit);

        // history replace
        history.replace({
            pathname: location.pathname,
            search: searchParams.toString()
        });
    };
    const afterUpdateHandler = ()=>{
        setisEdit(false);
        refetch();
    };

    if (isLoading) {
        return (
            <LoadingDataCard />
        );
    } else {
        return (
            <div>
                <div
                    className="preview-heading"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px',
                        borderBottom: '1px solid #e0e0e0',
                        paddingBottom: '8px'
                    }}
                >
                    <p
                        style={{
                            fontWeight: '600',
                            fontSize: '13px',
                            textTransform: 'uppercase',
                            color: 'black'
                        }}
                    >
                                        General Information
                    </p>
                    <Button onClick={handleEdit} style={{ fontSize: '13px', color: 'teal' }}>
                        {
                            isEdit
                                ? <>
                                            Cancel
                                </>
                                : <>
                                    <Icon as={CiEdit} w={4} h={4} mr={1} />
                                                    Edit Details

                                </>
                        }
                    </Button>

                </div>
                <div className="preview-body">

                    {
                        (isEdit)
                            ? <RealtorForm
                                data={ data}
                                handleCancel={handleEdit}
                                afterUpdateHandler={afterUpdateHandler}
                                defaultValues={mapResponseToDefaults(REALTOR_DEFAULT_VALUE , data) }
                            />
                            : <React.Fragment>

                                <div style={{ lineHeight: '2.5rem' }}>
                                    <p><strong>Realtor ID</strong><br />{data?.realtorId}</p>
                                    <p><strong>Email</strong><br />{data?.ContactPointEmailValue}</p>
                                    <p><strong>Phone</strong><br />{viewMobile(data)}</p>

                                    <p><strong>First Name</strong><br />{data?.FirstName}</p>

                                    <p><strong>Last Name</strong><br />{data?.LastName}</p>

                                    <p><strong>Bio</strong><br /></p>
                                    <p>
                                        {data?.collateral?.biotext || 'N/A'}
                                    </p>
                                    <p><strong>Website</strong> </p>
                                    <Link target='_blank' rel="noopener noreferrer" href={ (data?.website && data?.website.includes('https://') ? data?.website : 'https://' + data?.website)} color='brand.500'>
                                        <Flex align="center" gap={1}>
                                            {data?.website || 'N/A'}
                                            {
                                                data?.website && <FaExternalLinkAlt/>
                                            }
                                        </Flex>
                                    </Link>

                                    <p><strong>Onboarding Status</strong><br /></p>
                                    {
                                        data?.indicator === 2
                                            ? <p className='success-text'>Completed</p>
                                            : <p className='danger-text'>In Progress</p>
                                    }
                                    <p><strong>Address</strong><br />{getAddressView(data)}</p>
                                    <p><strong>Last Updated On</strong><br />{viewDateAndTime(data?.updatedAt)}</p>
                                </div>
                                <div className="preview-box">
                                    <div className="preview-heading space-between-box">
                                    State Licenses
                                    </div>

                                    <div className="outline-table">
                                        {
                                            (data && data?.Statelicenses.length > 0 && data?.Statelicenses?.map((state,index)=>(
                                                <Tag colorScheme='teal' key={index} m={2} size='md'>{state.label}</Tag>
                                            ))) || <TabField value={<p>Doesn&apos;t have any state license</p>}/>
                                        }

                                    </div>
                                </div>

                            </React.Fragment>

                    }
                </div>

            </div>
        );
    }
}
